export const baseUrl = "https://api.adnuntius.com/api";
